import React from "react";
import { flushSync } from "react-dom";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes() && window.location.pathname !== "/") {
  hydrateRoot(rootElement, app);
} else {
  const root = createRoot(rootElement);
  flushSync(() => {
    root.render(app);
  });
}
